import { SvgIcon, SvgIconProps } from '@mui/material';

/** @deprecated Use theme-next icons or move into theme-next folder if it doesn't exists */
export const CoContractorIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon viewBox="0 0 16 24" htmlColor="#0AB912" {...props}>
            <path d="M13.029 7.707c0 2.773-2.248 5.02-5.021 5.02-2.773 0-5.021-2.247-5.022-5.02 0-2.773 2.249-5.021 5.022-5.021s5.021 2.248 5.021 5.02zm.705-2.326l-.248-3.11-3.109-.248L8.004 0 5.629 2.023l-3.107.248-.248 3.11L.25 7.754l2.024 2.373.248 3.109 2.413.193v10.676l3.062-3 3.074 3V13.429l2.415-.193.248-3.11 2.022-2.372-2.022-2.373z" />
            <path d="M6.87 5.25h.187c.125 0 .245.03.36.094.08.047.134.103.16.168.034.086.051.263.051.53v3.423c0 .318-.031.518-.094.6-.099.129-.258.193-.477.193H6.87v.144h2.269v-.144h-.191c-.125 0-.245-.031-.356-.094-.083-.047-.138-.103-.163-.168-.034-.086-.051-.263-.051-.531V6.043c0-.318.033-.518.097-.602.1-.127.256-.191.473-.191h.191v-.145H6.87v.145z" />
        </SvgIcon>
    );
};
